'use client'
/* eslint-disable no-nested-ternary */
import styled from 'styled-components'
import { SCREEN_SIZE } from '../../../lib/Media'

const getMaxWidth = ({ websiteTheme }) => {
  switch (websiteTheme) {
    case 'Beauty':
    case 'Titan':
    case 'Moonshot':
    case 'Fashion':
    case 'Pharma':
    case 'Gifts':
    case 'Default-Theme': {
      return '100%'
    }
    case 'HealthNext':
    case 'MediCore': {
      return '1276px'
    }
    default: {
      return '150rem'
    }
  }
}

const getPaddingLeft = (websiteTheme, pageName) => {
  switch (websiteTheme) {
    case 'Zopnow': {
      if (pageName === 'HOME') return '22rem'
      return '25rem'
    }
    case 'theme-wsi': {
      if (['CHECKOUT', 'Order', 'Account'].includes(pageName)) {
        return ''
      }
      return '22rem'
    }
    default: {
      return ''
    }
  }
}

export const SectionWrapper = styled.div`
  display: ${({ showSection, home }) => !showSection && home && 'none'};
  min-height: ${({ childLength }) => (childLength ? 'fit-content' : '30rem')};
  grid-area:${({
    quickTheme,
    categoryPage,
    categoryCollection,
    productCollection,
    subCategoryPage,
    imageSlideShow
  }) => {
    if (quickTheme && categoryPage && subCategoryPage && categoryCollection  )
       return '1 / 1 / 3 / 2'
    if (quickTheme && categoryPage && subCategoryPage && categoryCollection && imageSlideShow)
      return '1 / 2 / 2 / 3'
    if (quickTheme && categoryPage && subCategoryPage && categoryCollection && productCollection)
      return '2 / 2 / 3 / 3'
  }};
  margin: ${({ websiteTheme }) =>
    (websiteTheme === 'Quick' || websiteTheme === 'Bazar') && ' 0 auto'};
  &.has-content {
    margin-bottom: ${({ home, isMarquee }) =>
      !isMarquee && home ? '2rem' : '0'};
    ${SCREEN_SIZE.From.Tablet} {
      margin-bottom: ${({ home, isMarquee }) =>
        !isMarquee && home ? '3rem' : '0'};
    }
  }
  ${SCREEN_SIZE.Below.MobileL} {
    :last-child {
      margin-bottom: 0px !important;
    }
    min-height: ${({ childLength, websiteTheme }) =>
      websiteTheme === 'Gifts' ||
      websiteTheme === 'MediCore' ||
      websiteTheme === 'Quick' ||
      websiteTheme === 'Getz' ||
      websiteTheme === 'Lifestyle' ||
      websiteTheme === 'InkGlow' ||
      websiteTheme === 'Glide' ||
      websiteTheme === 'Bazar' ||
      websiteTheme === 'Personal-care' ||
      childLength
        ? 'fit-content'
        : '8rem'};
    width: ${({
      quickTheme,
      categoryPage,
      categoryCollection,
      productCollection,
      subCategoryPage,
      imageSlideShow
    }) => {
      if (quickTheme && categoryPage && subCategoryPage && categoryCollection) return '80%'
      if (quickTheme && categoryPage && categoryCollection && !subCategoryPage) return '28%'
      if(quickTheme && categoryPage && subCategoryPage && imageSlideShow) return 'auto'
      if (quickTheme && categoryPage && categoryCollection && productCollection)
        return '70%'
      if (quickTheme && categoryPage && productCollection) return '100%'
      if (quickTheme) return '88%'
      return 'auto'
    }};
  }
  ${SCREEN_SIZE.From.Desktop} {
    width: ${({ websiteTheme }) =>
      (websiteTheme === 'Quick' || websiteTheme === 'Bazar') && '80%'};
    min-height: ${({ childLength, websiteTheme }) =>
      websiteTheme === 'Gifts' ||
      websiteTheme === 'Sports' ||
      websiteTheme === 'MediCore' ||
      websiteTheme === 'Quick' ||
      websiteTheme === 'Getz' ||
      websiteTheme === 'Glide' ||
      websiteTheme === 'Lifestyle' ||
      websiteTheme === 'InkGlow' ||
      websiteTheme === 'Bazar' ||
      websiteTheme === 'Personal-care' ||
      childLength
        ? 'fit-content'
        : '30rem'};
    width: ${({
      quickTheme,
      categoryPage,
      categoryCollection,
      productCollection,
      subCategoryPage,
      imageSlideShow
    }) => {
      if (quickTheme && categoryPage && subCategoryPage && categoryCollection) return '80%'
      if (quickTheme && categoryPage && categoryCollection && !subCategoryPage) return '28%'
      if(quickTheme && categoryPage && subCategoryPage && imageSlideShow) return 'auto'
      if (quickTheme && categoryPage && categoryCollection && productCollection)
        return '76%'
      if (quickTheme && categoryPage && productCollection) return '100%'
      if (quickTheme) return '88%'
      return 'auto'
    }};
  }
`
export const StyledMain = styled.main`
  background-color: ${({ websiteTheme, theme }) =>
    websiteTheme === 'Pharma'
      ? theme.mainBackground
      : websiteTheme === 'Darknight' && '#000'};
  min-height: calc(100vh - 8rem);
  max-width: ${getMaxWidth};
  margin: 0 auto;
  margin-bottom: ${({ websiteTheme }) => websiteTheme === 'Sports' && '10rem'};
  padding: ${({ getzTheme, zopstore }) => (getzTheme || zopstore) && '0 4rem'};
  ${SCREEN_SIZE.Below.MobileL} {
    padding: ${({ getzTheme, zopstore }) =>
      (getzTheme || zopstore) && '0 2rem'};
    margin-top: ${({ quickTheme }) => quickTheme && '2rem'};
    display: ${({ quickTheme, categoryPage, subCategoryPage }) =>
      quickTheme && categoryPage && subCategoryPage && 'grid'};
    grid-template-columns:${({ quickTheme, categoryPage,subCategoryPage }) =>
      quickTheme && categoryPage &&subCategoryPage && '25% 70%'};
    grid-template-rows: ${({ quickTheme, categoryPage,subCategoryPage }) =>
      quickTheme && categoryPage && subCategoryPage && 'auto'};
    gap: ${({ quickTheme, categoryPage, subCategoryPage }) =>
      quickTheme && categoryPage && subCategoryPage && '1rem'};
  }
  ${SCREEN_SIZE.From.Tablet} {
    min-height: calc(100vh - 9.5rem);
    padding: ${({ getzTheme, zopstore }) =>
      (getzTheme || zopstore) && '0 6rem'};
    margin-left: ${({ websiteTheme }) =>
      websiteTheme === 'theme-wsi' && '2rem'};
  }
  ${SCREEN_SIZE.From.Desktop} {
    min-height: ${({ websiteTheme }) =>
      websiteTheme === 'Moonshot' && 'calc(100vh - 10.5rem)'};
    min-height: ${({ websiteTheme, pageName, cartProductsCount }) =>
      websiteTheme === 'Fashion' &&
      pageName === 'CART' &&
      !cartProductsCount &&
      'calc(100vh - 50rem)'};
    margin-top: ${({ moonshotTheme, pageName }) =>
      moonshotTheme && pageName === 'HOME' && '3rem'};
    padding: ${({ getzTheme, zopstore }) =>
      (getzTheme || zopstore) && '0 8rem'};
    max-width: ${({ getzTheme, zopstore }) =>
      (getzTheme || zopstore) && 'unset'};
    padding-left: ${({ hasSideMenu, websiteTheme, pageName }) =>
      hasSideMenu && getPaddingLeft(websiteTheme, pageName)};
    margin-top: ${({ quickTheme }) => quickTheme && '2rem'};
    display: ${({ quickTheme, categoryPage, subCategoryPage }) =>
      quickTheme && categoryPage && subCategoryPage && 'grid'};
    grid-template-columns:${({ quickTheme, categoryPage,subCategoryPage }) =>
      quickTheme && categoryPage &&subCategoryPage && '25% 75%'};
    grid-template-rows: ${({ quickTheme, categoryPage,subCategoryPage }) =>
      quickTheme && categoryPage && subCategoryPage && 'auto'};
    width: ${({ quickTheme, categoryPage }) =>
      quickTheme && categoryPage && '88%'};
    gap: ${({ quickTheme, categoryPage, subCategoryPage }) =>
      quickTheme && categoryPage && subCategoryPage && '2.4rem'};
  }
`
